import React from 'react'
import moment from 'moment'
import Cookie from 'js-cookie'
import { Link as RLink, NavLink as RNLink } from 'react-router-dom'

export const Link = ({ to, children, ...rest }) =>
  /^https?\:\/{2}/.test(to) ? (
    <a href={to} {...rest}>
      {children}
    </a>
  ) : (
    <RLink to={to} {...rest}>
      {children}
    </RLink>
  )

export const NavLink = ({ to, children, activeClassName, ...rest }) =>
  /^https?\:\/{2}/.test(to) ? (
    <a href={to} {...rest}>
      {children}
    </a>
  ) : (
    <RNLink to={to} activeClassName={activeClassName} {...rest}>
      {children}
    </RNLink>
  )

export const timeFormat = (time, rule = 'YYYY-MM-DD HH:mm:ss') =>
  moment(time * 1000).format(rule)

export const randomColor = num =>
  [
    'magenta',
    'red',
    'volcano',
    'orange',
    'gold',
    'cyan',
    'blue',
    'geekblue',
    'purple',
  ]
    .sort(() => 0.5 - Math.random())
    .slice(0, num)

export const isArray = Array.isArray.bind(Array)
export const isString = s => typeof s === 'string'

export function flow(funcs) {
  const length = funcs ? funcs.length : 0
  let index = length
  while (index--) {
    if (typeof funcs[index] !== 'function') {
      throw new TypeError('Expected a function')
    }
  }
  return (...args) => {
    let _index = 0
    let result = length ? funcs[_index].apply(null, args) : args[0]
    while (++_index < length) {
      result = funcs[_index].call(null, result)
    }
    return result
  }
}

export const generateRandomNumber = (n: number) => {
  if (n < 1) {
    throw new Error('请输入合法位数')
  }
  return Math.floor(
    Math.random() * 9 * Math.pow(10, n - 1) + Math.pow(10, n - 1),
  )
}

export const addEvent = (dom, evtType, handler, useCapture?) => {
  if (dom.addEventListener) {
    dom.addEventListener(evtType, handler, useCapture)
  } else {
    dom.attachEvent(`on${evtType}`, handler)
  }
}

export const utf8ToBase64 = utf8 =>
  window.btoa(unescape(encodeURIComponent(utf8)))

export const isProd = () => {
  return location.host === 'jzxy.jingzhuan.cn'
}

export const getUrlParam = name => {
  const regex = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  const match = window.location.search.substr(1).match(regex)

  if (match != null) {
    return unescape(decodeURI(match[2]))
  }
  return null
}

export const delUrlParam = params => {
  const { URL, location, history } = window
  if (!URL || !history) {
    return
  }

  const obj = new URL(location.href)
  params.forEach(item => obj.searchParams.delete(item))
  history.pushState({}, '', obj.href)
}

export const getToken = () => {
  return Cookie.get('AUTHOR_TOKEN')
}

export const setToken = token => {
  const domain = location.hostname
  Cookie.set('AUTHOR_PROJECT', 'soft', { domain })
  Cookie.set('AUTHOR_TOKEN', token, { domain })
}
